import { render, staticRenderFns } from "./imgKat.vue?vue&type=template&id=d6bbf27a"
import script from "./imgKat.vue?vue&type=script&lang=js"
export * from "./imgKat.vue?vue&type=script&lang=js"
import style0 from "./imgKat.vue?vue&type=style&index=0&id=d6bbf27a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports